import { QueryErrorBoundary } from '@components/errors/QueryErrorBoundary';
import { StudentDetailsTab } from '@features/student-page/components/StudentDetailsTab';
import { createFileRoute } from '@tanstack/react-router'
import { LoadingIndicator } from '@ui/LoadingIndicator';
import { Suspense } from 'react';

export const Route = createFileRoute('/_layout/students/$studentNo/details')({
    component: RouteComponent,
    staticData: {
        crumb: {
            label: 'Details',
        }
    }
})

function RouteComponent() {

    const { studentNo } = Route.useParams()

    return (
        <div className='h-full min-h-0'>
            <QueryErrorBoundary title='Failed to load student summary'>
                <Suspense fallback={<LoadingIndicator resource='student summary' />}>
                    <StudentDetailsTab studentNo={studentNo} />
                </Suspense>
            </QueryErrorBoundary>
        </div>
    )
}
